import { http } from '@/utils/api'
import * as Sentry from '@/core/sentry'
import type { IconName, BadgeType } from '@easybell/caramel-vue3'

export type NavigationEntry = {
  /** i18n translation key */
  label: string
  icon: IconName
  path: string | null
  pathKey: string | null
  children: NavigationEntry[]
  hasTopDivider?: boolean | null
  hasBottomDivider?: boolean | null
  badge?: { label: string; type?: BadgeType } | null
  tone?: 'default' | 'danger' | null
}

export type Navigation = {
  topLinks: NavigationEntry[]
  bottomLinks: NavigationEntry[]
  popoutLinks: NavigationEntry[]
  user: {
    name: string
    phoneNumber: string
    email: string
    customerId: string
  }
  uca: boolean
}

export async function loadNavigation() {
  try {
    const url = 'navigation'

    const { data } = await http.get(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error: any) {
    Sentry.captureException(error)

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
